<template>
  <el-dialog title="订单退款" v-model="refundVisible" width="60%">
    <el-form label-width="80px" class="mt-10">
      <el-form-item label="退款金额">
        <el-input-number
          v-model="form.amount"
          :step="0.01"
          :min="0"
          :max="getRefundAmount()"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="退款原因">
        <el-input
          v-model="form.refundReason"
        ></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="refundVisible = false">取 消</el-button>
      <el-button :loading="refundLoading" type="primary" @click="refundOrder">
        确 定
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import {
  refundApartmentOrder,
} from '@/api/order'
import {
  checkRefundAmount,
} from '@/utils/tool'
export default {
  name: 'Refund',
  emits: ['fetch-data'],
  data() {
    return {
      refundVisible: false,
      refundLoading: false,
      form: {
        amount: '',
        refundReason: '',
      },
      showForm:{}
    }
  },
  methods: {
    showRefund(showForm) {
      this.form = {
        amount: '',
        refundReason: ''
      }
      this.showForm = showForm
      this.refundVisible = true
    },
    async refundOrder() {
      const param = Object.assign(this.form, {
        orderId: this.showForm.orderId
      })
      this.refundLoading = true
      const result = await refundApartmentOrder(param)
      this.refundLoading = false
      if (!!result) {
        this.refundVisible = false
        this.dialogFormVisible = false
        this.$message.success('订单退款成功')
        this.$emit('fetch-data')
      }
    },
    // 获取能退的金额
    getRefundAmount() {
      return checkRefundAmount(this.showForm)
    },
  },
}
</script>

<style lang="scss" scoped>
.mt-10 {
  margin-top: 10px;
}
</style>
